namespace uh.scene {

    export class Preloader extends Phaser.Scene {

        preload() {
            for (let f of window["customFontFamilies"]) {
                this.add.text(-100, -100, "v1", {
                    "fontFamily": f,
                    "fontSize": 14,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
            }
        }

        create() {
            let p:Phaser.GameObjects.Container = new Phaser.GameObjects.Container(this);
            this.children.add(p);
            let txt:Phaser.GameObjects.Text = this.add.text(Math.floor(this.scale.width/2), Math.floor(this.scale.height/2), "0%", {
                "fontFamily": 'Lo-Res',
                "fontSize": 50,
                "color": "#FFFFFF",
                "align": 'center'
            });
            txt.setOrigin(0.5, 0.5);
            p.add(txt);
            
            this.load.pack('preloader', 'assets/pack.json');

            this.load.image('uh_logo', "assets/imgs/logo/"+"uh_logo_"+window["-LANG-"]+".png");

            this.load.on('progress', (value:number) => {
                txt.setText(Math.ceil(value*100) + "%");
            }, this);

            this.load.on('complete', () => {
                this.nextScene();
            });

            this.load.start();
        }

        private nextScene():void {
            game.scene.remove('Preloader');
            game.scene.add('ScreenMain', uh.scene.ScreenMain, true);
        }
    }
}